import Template from "backbone/shared/templates/password_requirements.js.hamlc"

export default class PasswordRequirementsView extends Backbone.View
  events:
    "keyup #user_password" : "updatePasswordRequirementsStatus"

  initialize: (options) ->
    @specialCharacters = options.specialCharactersString.split("")
    @passwordField = @$el.find("#user_password")
    @requirementDiv = @$el.find(".js-password-requirements")
    @renderRequirements()

  updatePasswordRequirementsStatus: ->
    @renderRequirements()
    @renderPasswordField()

  hasMoreThan8Characters: ->
    @passwordField.val().length >= 8

  hasOneDigitAndOneLetter: ->
    /\d/.test(@passwordField.val()) && /[a-z]/i.test(@passwordField.val())

  hasOneSpecialCaracter: ->
    for specialCharacter in @specialCharacters
      return true if @passwordField.val().indexOf(specialCharacter) >= 0
    false

  isEmpty: ->
    @passwordField.val().length == 0

  renderErrorOrSuccessCssClass: (fieldStatus) ->
    if @isEmpty()
      return "empty"
    else if fieldStatus
      return "success"
    else
      return "error"

  renderPasswordField: ->
    if @isEmpty() || (@hasMoreThan8Characters() && @hasOneDigitAndOneLetter() && @hasOneSpecialCaracter())
      @$el.find(".inline-checkbox-wrapper").removeClass("error")
    else
      @$el.find(".inline-checkbox-wrapper").addClass("error")

  renderRequirements: ->
    @requirementDiv.empty().append Template(
      specialCharacters: @specialCharacters,
      hasMoreThan8Characters: @renderErrorOrSuccessCssClass(@hasMoreThan8Characters()),
      hasOneDigitAndOneLetter: @renderErrorOrSuccessCssClass(@hasOneDigitAndOneLetter()),
      hasOneSpecialCaracter: @renderErrorOrSuccessCssClass(@hasOneSpecialCaracter()),
    )
    this



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/password_requirements_view.js.coffee